export const craft_diy = [
  { char: '🎨', name: 'Palette', nameZh: '藝術創作', keywords: ['paint', 'art', 'draw'], hot: true },
  { char: '🧵', name: 'Thread', nameZh: '裁縫設計', keywords: ['sew', 'fashion', 'diy'] },
  { char: '🧶', name: 'Yarn', nameZh: '編織時光', keywords: ['knit', 'handmade', 'winter'] },
  { char: '🪡', name: 'Needle', nameZh: '精細手作', keywords: ['sew', 'detail', 'craft'] },
  { char: '🔨', name: 'Hammer', nameZh: '木工/修繕', keywords: ['wood', 'fix', 'build'] },
  { char: '🪚', name: 'Saw', nameZh: '結構切割', keywords: ['cut', 'wood', 'work'] },
  { char: '📐', name: 'Ruler', nameZh: '精準量測', keywords: ['math', 'measure', 'design'] },
  { char: '🖌️', name: 'Paintbrush', nameZh: '書法/繪畫', keywords: ['art', 'write', 'draw'] },
  { char: '🏺', name: 'Amphora', nameZh: '陶藝/古物', keywords: ['pottery', 'clay', 'history'] },
  { char: '🧱', name: 'Brick', nameZh: '基礎建設', keywords: ['build', 'wall', 'base'] },
  { char: '🪜', name: 'Ladder', nameZh: '步步高升', keywords: ['up', 'step', 'climb'] },
  { char: '🧷', name: 'Safety Pin', nameZh: '連結與固定', keywords: ['connect', 'fix', 'hold'] },
];